import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShoppingCart } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { euro } from "@/pages/Services";

export const BuyTrackButton = ({ rel, t, i }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", accept_terms: false, accept_withdrawal: false });
  const [busy, setBusy] = useState(false);
  if (!t.audio_url || !(t.price >= 1)) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const pay = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/shop/checkout", { ...f, release_id: rel.id, track_id: t.id, origin_url: window.location.origin });
      localStorage.setItem("tga_last_order", JSON.stringify({ id: data.order_id, token: data.token }));
      window.location.href = data.checkout_url;
    } catch (err) { toast.error(formatError(err)); setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 rounded-full border border-hot/60 text-hot px-3 py-1.5 text-xs font-bold hover:bg-hot hover:text-[#151827] transition-colors whitespace-nowrap" data-testid={`track-buy-btn-${i}`}>
        <ShoppingCart className="h-3.5 w-3.5" /> {euro(t.price)}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1e2236] border-white/10 text-white" data-testid="buy-dialog">
          <DialogHeader>
            <DialogTitle className="font-display uppercase">Acquista “{t.title}”</DialogTitle>
            <DialogDescription className="text-zinc-400">Download del file audio originale · {euro(t.price)} IVA inclusa. Riceverai il link per scaricarlo via email subito dopo il pagamento.</DialogDescription>
          </DialogHeader>
          <form onSubmit={pay} className="space-y-3">
            <Input required placeholder="Nome e cognome" value={f.name} onChange={set("name")} className="bg-[#262b42] border-white/15" data-testid="buy-name-input" />
            <Input required type="email" placeholder="Email (per ricevere il download)" value={f.email} onChange={set("email")} className="bg-[#262b42] border-white/15" data-testid="buy-email-input" />
            <label className="flex gap-2 text-xs text-zinc-300"><input type="checkbox" required checked={f.accept_terms} onChange={set("accept_terms")} data-testid="buy-terms" /> <span>Ho letto e accetto i <Link to="/termini" target="_blank" className="text-emerald-400 underline">Termini e Condizioni</Link> e l'informativa privacy.</span></label>
            <label className="flex gap-2 text-xs text-zinc-300"><input type="checkbox" required checked={f.accept_withdrawal} onChange={set("accept_withdrawal")} data-testid="buy-withdrawal" /> Chiedo di poter scaricare subito il brano e prendo atto che così perdo il diritto di recesso (art. 59 Codice del Consumo).</label>
            <button disabled={busy} className="w-full rounded-full bg-emerald-500 text-[#151827] py-3 font-bold hover:bg-emerald-400 disabled:opacity-60 inline-flex justify-center items-center gap-2" data-testid="buy-pay-btn">
              {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Apertura pagamento sicuro…</> : `Paga ${euro(t.price)}`}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
